import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"5.5\" cy=\"4\" r=\"1.25\" fill=\"currentColor\"></circle><circle cx=\"10.5\" cy=\"4\" r=\"1.25\" fill=\"currentColor\"></circle><circle cx=\"5.5\" cy=\"8\" r=\"1.25\" fill=\"currentColor\"></circle><circle cx=\"10.5\" cy=\"8\" r=\"1.25\" fill=\"currentColor\"></circle><circle cx=\"5.5\" cy=\"12\" r=\"1.25\" fill=\"currentColor\"></circle><circle cx=\"10.5\" cy=\"12\" r=\"1.25\" fill=\"currentColor\"></circle>", 6)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })